module.exports = __webpack_public_path__ + "static/media/brand.c107dda7.svg";